import BeaconAction from '@tencent/beacon-web-sdk';
(function() {
  let beacon = new BeaconAction({
    appkey: '0WEB0TYYYA4Y1N8X'
  });
  beacon.onDirectUserAction('v#page', {
    page: location.href,
    time: new Date().getTime(),
    lang: 'zh',
    page_id: 'h5',
    user_id: '0'
  });
})();
